define([
    'jquery',
], function ($) {
    'use strict';

    /**
     * equalizes the heights of all elements in a jQuery collection
     * thanks to John Resig for optimizing this!
     * usage: $("#col1, #col2, #col3").equalizeCols();
     */
    var init = function () {
        $.fn.equalizeCols = function () {
            var height = 0,
                reset = "auto";

            return this
                .css("height", reset)
                .each(function () {
                    height = Math.max(height, this.offsetHeight);
                })
                .css("height", height)
                .each(function () {
                    var h = this.offsetHeight;
                    if (h > height) {
                        $(this).css("height", height - (h - height));
                    }
                });
        };

        $("li.cat").equalizeCols();
    };

    return {
        init: init
    }
});